// The structured 422 the monolith renders when the hiring goal designation
// guard refuses a move onto the hire-counting stage: the applicant has not
// named the goal the hire counts toward, or named one that has filled.

// Mirrored against HiringGoals::RendersDesignationRefusal::ERROR_TYPE in
// apps/hire through tools/contract-mirrors/mirrors.json.
export const HIRING_GOAL_REQUIRED_ERROR_TYPE = 'hiring_goal_required';

export interface HiringGoalRequirement {
  reason: 'choice_required' | 'goal_filled';
  funnel_id: string | null; // eslint-disable-line camelcase
  blocked_applicants: Array<{ id: string; name: string | null }>; // eslint-disable-line camelcase
  hiring_goals: Array<{ id: string; goal: number; hires_count: number }>; // eslint-disable-line camelcase
}

// What the axios interceptor rejects with when the response body carries
// `error_type: 'hiring_goal_required'`.
export interface HiringGoalRequiredRejection {
  errorType: typeof HIRING_GOAL_REQUIRED_ERROR_TYPE;
  message: string;
  hiringGoalRequirement: HiringGoalRequirement | null;
}

export function isHiringGoalRequiredRejection(
  value: unknown,
): value is HiringGoalRequiredRejection {
  if (value == null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as { errorType?: unknown; message?: unknown };
  return (
    candidate.errorType === HIRING_GOAL_REQUIRED_ERROR_TYPE &&
    typeof candidate.message === 'string'
  );
}
